export const referrals = {
  menu: {
    label: "Refer & earn",
    badge: "Earn",
  },
  welcomeCard: {
    title: "Your plan could be free",
    desc: "Invite other hosts and earn a share of everything they pay, forever.",
  },
  page: {
    loading: "Loading your referrals…",
    previewNotice: "Preview with sample data. Your real referrals will show up here once the program is live.",
  },
  hero: {
    title: "Invite other hosts and use WACheckin for free",
    subtitle: "For every host who subscribes with your link, you earn {percent}% of everything they pay, every month, forever. Your colleague starts with {friendPercent}% off.",
    personal: "Your plan costs {price} a month. With {count} referrals like you, you never pay again.",
    personalGeneric: "With {count} paying hosts like you, your plan is free.",
  },
  rewards: {
    youGet: "You get",
    youGetBig: "{percent}% of every payment",
    youGetSmall: "from every host you invite, every month, forever",
    friendGets: "They get",
    friendGetsBig: "{percent}% off",
    friendGetsSmall: "their first {months} months",
    example: "If you invite a host with {units} apartments, you earn about {amount} a year for as long as they stay.",
  },
  welcomeOffer: {
    title: "Your welcome gift",
    text: "{name} invited you to WACheckin: you get {percent}% off your first {months} months. It's applied when you subscribe.",
  },
  share: {
    title: "Your invite link",
    codeLabel: "Your code",
    copy: "Copy link",
    copied: "Copied",
    whatsapp: "WhatsApp",
    invite: "Send by email",
    more: "More",
    message: "Check out WACheckin: I use it for online check-in, guest messages and connecting Booking and Airbnb, and it saves me a lot of time. With my link you get {percent}% off your first {months} months: {link}",
    emailSubject: "Get {percent}% off WACheckin with my link",
  },
  invite: {
    title: "Invite by email",
    subtitle: "We'll send your colleague a personal invitation with your link and their {percent}% discount.",
    emailLabel: "Colleague's email",
    emailPlaceholder: "name@company.com",
    languageLabel: "Email language",
    cancel: "Cancel",
    send: "Send invitation",
    sending: "Sending…",
    successTitle: "Invitation sent!",
    successDesc: "We've sent your invitation to {email}.",
    another: "Invite another colleague",
    close: "Close",
    errors: {
      invalidEmail: "Enter a valid email address.",
      selfInvite: "You can't send the invitation to your own email.",
      alreadyInvited: "You already invited this email recently. You can try again in a few days.",
      dailyLimit: "You've reached today's invitation limit. Try again tomorrow.",
      tooFast: "Too many attempts in a row. Wait a minute and try again.",
      generic: "We couldn't send the invitation. Please try again.",
    },
  },
  message: {
    title: "Ready-to-share message",
    hint: "Paste it in your host groups, forums or social media. It works best with a line of your own.",
    copy: "Copy message",
  },
  how: {
    title: "How it works",
    stepLabel: "Step {n}",
    step1Title: "Share your link",
    step1Desc: "By WhatsApp, email or in your host groups.",
    step2Title: "They subscribe with a discount",
    step2Desc: "They sign up with your link and start with {percent}% off.",
    step3Title: "You earn every month",
    step3Desc: "{percent}% of every payment goes to your credit, forever. The first one counts after {days} days.",
  },
  results: {
    title: "Your results",
    celebrate: "You've earned {amount} so far.",
    coverage: "Your referrals already cover {percent}% of your plan",
    coverageFree: "Your plan is already free",
    coverageHint: "Your plan costs {price} a month and your referrals bring you {earning} a month.",
  },
  stats: {
    invited: "Invited",
    subscribed: "Paying",
    monthlyEarning: "Monthly earnings",
    creditAvailable: "Available credit",
    creditEarned: "{amount} earned in total",
    creditHint: "Deducted automatically from your next invoice",
  },
  list: {
    title: "Your referrals",
    colName: "Account",
    colDate: "Signed up",
    colStatus: "Status",
    colReward: "What you earn",
    empty: "You haven't invited anyone yet. The first host who subscribes with your link starts earning you credit every month.",
  },
  status: {
    registered: "Signed up",
    subscribed: "Paying",
    rewarded: "Earning",
    canceled: "Cancelled",
    rejected: "Not eligible",
  },
  reward: {
    waiting: "Waiting for their first payment",
    startsOn: "You start earning on {date}",
    earning: "{monthly} a month, {earned} in total",
    earningNoPlan: "{earned} in total",
    canceled: "{earned} earned",
  },
  reasons: {
    duplicate: "Duplicate account",
    selfReferral: "Self-referral",
  },
  faq: {
    title: "Frequently asked questions",
    howMuchQ: "How much do I earn?",
    howMuchA: "{percent}% of everything each host you invite pays (excluding tax), every month and forever, with no limit on referrals. If they pay {price} a month, you earn about {amount} each month.",
    whenQ: "When do I get it?",
    whenA: "Every time your referral pays, it's added to your credit automatically. Their first payment counts after {days} days, in case they cancel right after subscribing.",
    whereQ: "Where is the credit used?",
    whereA: "It's deducted automatically from your next WACheckin invoices. If you haven't subscribed yet, it's applied to your first invoice.",
    limitQ: "Is there a limit?",
    limitA: "There's no limit on referrals or time. The only one: the credit you've saved and not spent goes up to {months} months of your plan. While you're at that cap your plan stays free; anything beyond it isn't saved.",
    stopQ: "When do I stop earning?",
    stopA: "If your referral cancels, you stop earning from them. If you cancel, you stop accumulating credit.",
    whoQ: "Who can I invite?",
    whoA: "Any host or hotel that doesn't use WACheckin yet. Self-referrals and duplicate accounts are not eligible.",
  },
};
